import { combineReducers } from 'redux';
import { getType } from 'typesafe-actions';
import { actions } from '..';
import { Actions, StoreState } from '../types';
import { ItemSelected } from '../../Components/SearchPage';
import { GridData } from '../../api';
import { MediaCallHistoryEntry } from '../../model';

function results(state: GridData<MediaCallHistoryEntry> | null = null, action: Actions): GridData<MediaCallHistoryEntry> | null {
  switch (action.type) {
    case getType(actions.fetchAdavncedSearchResponse):
      {
        return action.payload
      }

    case getType(actions.clearAdvancedSearchResults):
      return null

    default:
      return state
  }
}

export default combineReducers({
  results,
})

function getRoot(state: StoreState) { return state.search }

export function getAdvancedSearchResults(state: StoreState) {
  return getRoot(state).results
}

export function selectAdvancedSearchItem(state: StoreState, item: ItemSelected) {
  const data = getAdvancedSearchResults(state)
  if (data) {
    for (const call of data.rows) {
      if (call.id === item.id)
        return call
    }
  }

  return null
}

